<section class="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
  <header class="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
    <div class="min-w-0">
      <h3 class="text-base font-bold tracking-tight text-gray-800">Mitarbeiteridentifikation</h3>
      <p class="mt-1 text-sm text-gray-500">
        Erlaubt diesem Mitarbeiter, sich am Kassengerät für kritische Aktionen (z.&nbsp;B. manueller Geldtransit)
        per persönlicher 6-stelliger PIN auszuweisen. Die PIN vergibt der Mitarbeiter selbst im Self-Service –
        sie ist hier nicht einsehbar oder setzbar.
      </p>
    </div>

    <!-- Enable/disable toggle (role=switch so assistive tech announces the on/off state). -->
    <button type="button" role="switch" [attr.aria-checked]="enabled()" (click)="toggle()" [disabled]="saving()"
            class="relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full transition-colors
                   duration-200 focus:outline-none focus:ring-2 focus:ring-theme-primary-500 focus:ring-offset-2
                   disabled:cursor-not-allowed disabled:opacity-50"
            [class.bg-theme-primary-600]="enabled()" [class.bg-gray-200]="!enabled()">
      <span class="sr-only">Mitarbeiteridentifikation umschalten</span>
      <span aria-hidden="true"
            class="inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-200"
            [class.translate-x-6]="enabled()" [class.translate-x-1]="!enabled()"></span>
    </button>
  </header>

  @if (enabled()) {
    <div class="flex flex-col gap-3 rounded-xl bg-gray-50 px-3 py-3 sm:flex-row sm:items-center sm:justify-between">
      <p class="text-sm text-gray-600">
        @if (hasPin()) {
          <span class="font-medium text-gray-700">Es ist eine PIN hinterlegt.</span>
          Beim Zurücksetzen muss der Mitarbeiter eine neue PIN vergeben.
        } @else {
          <span class="font-medium text-gray-700">Es ist noch keine PIN hinterlegt.</span>
          Der Mitarbeiter wird beim nächsten Login im Self-Service zur PIN-Vergabe aufgefordert.
        }
      </p>

      @if (hasPin()) {
        <button type="button" (click)="resetPin()" [disabled]="!canResetPin()"
                class="shrink-0 rounded-2xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700
                       shadow-sm transition-all duration-200 hover:bg-white disabled:cursor-not-allowed
                       disabled:opacity-50">
          @if (saving()) { Wird zurückgesetzt… } @else { PIN zurücksetzen }
        </button>
      }
    </div>
  }

  @if (successMessage(); as success) {
    <p class="mt-3 rounded-xl bg-green-50 px-3 py-2 text-sm font-medium text-green-700" role="status">{{ success }}</p>
  }
  @if (errorMessage(); as error) {
    <p class="mt-3 rounded-xl bg-red-50 px-3 py-2 text-sm font-medium text-red-700" role="alert">{{ error }}</p>
  }
</section>
